import {AfterViewInit, Component, OnInit} from '@angular/core';
import {PaymentService} from '../payment.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {CalculatorCarsComponent} from '../../calculator/calculator-cars.component';
import {MatDialog} from '@angular/material/dialog';
import {AcceptTermsComponent} from '../accept-terms/accept-terms.component';

@Component({
  selector: 'app-payment-green',
  templateUrl: './payment-green.component.html',
  styleUrls: ['./payment-green.component.scss']
})
export class PaymentGreenComponent implements OnInit, AfterViewInit {

  iframeUrl: SafeResourceUrl;
  succeededRetrieval = false;
  subscription: any = {loaded: false};
  loading = true;
  termsAccepted = false;


  constructor(
    private paymentService: PaymentService,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
    this.paymentService.getUserSubscription({}).subscribe(subscription => {
      this.loading = false;
      this.subscription = {...subscription, loaded: true};
    });
  }

  ngAfterViewInit() {
    const userId = sessionStorage.getItem('user-id');

  }

  openDialog() {
    const dialog = this.dialog.open(AcceptTermsComponent, {
      width: '80vw',
    });
    dialog.afterClosed().subscribe(result => {
      if (!result) {
        // this.router.navigate(['/account/calculate']);
      }
      if (result.approve) {
        this.termsAccepted = true;
      } else {

      }
    });
  }


  signupMonthly() {
    this.paymentService.getPaymentIframe({periodType: 'month'}).subscribe(res => {
        // this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res.Url);
        this.succeededRetrieval = res.success;
        console.log(res);
        window.open(res.Url, '_blank');
      }
    );
  }

  signupAnnual() {
    this.paymentService.getPaymentIframe({periodType: 'year'}).subscribe(res => {
        // this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res.Url);
        this.succeededRetrieval = res.success;
        console.log(res);

        window.open(res.Url, '_blank');
      }
    );
  }
}
